import {call, put, take, takeLatest} from 'redux-saga/effects';
import {apiFunctions} from '../../api/functions';
import {errorHandler} from '../../utils/errorHandling';
import {
  // get risk assessment tasks
  getRiskAssessmentTasksFailure,
  getRiskAssessmentTasksSuccess,
  //fetTaskDetail,
  taskDetailSuccess,
  taskDetailFailure,
  // create task
  createTaskFailure,
  createTaskSuccess,
  // update Task
  updateTaskSuccess,
  updateTaskFailure,
  //  delete Task
  deleteTaskSuccess,
  deleteTaskFailure,
  // 'No' Exposure to events
  markNoExpToUnWantedEventsFailure,
  markNoExpToUnWantedEventsSuccess,
  // Add Event Subcategory
  addSubCategoryEventsFailure,
  addSubCategoryEventsSuccess,
  // Delete subCategory from event
  deleteSubCategoryEventsSuccess,
  deleteSubCategoryEventsFailure,
  saveEventDetailSuccess,
  saveEventDetailFailure,
  eventDetailSuccess,
  eventDetailFailure,
  updateEventDetailSuccess,
  updateEventDetailFailure,
  getMachineLimitsSuccess,
  getMachineLimitsFailure,
  addMachineLimitsSuccess,
  addMachineLimitsFailure,
  updateTaskMediaSuccess,
  updateTaskMediaFailure,
 
  deleteTaskMediaSuccess,
  deleteTaskMediaFailure,
  uploadMediaSuccess,
  uploadMediaFailure,
  addAssumptionSuccess,
  addAssumptionFailure,
  getAssumptionSuccess,
  getAssumptionFailure,
  addRevisionHistorySuccess,
  addRevisionHistoryFailure,
  getRevisionHistorySuccess,
  getRevisionHistoryFailure,
  addAttendanceSuccess,
  getAttendanceSuccess,
  getAttendanceFailure,
  addAttendanceFailure,
  getEmployeeSuccess,
  getEmployeeFailure,
  getSummarySuccess,
  getSummaryFailure,
  //generate Excel Id
  generateExcelIdSuccess,
  generateExcelIdFailure,
  //generate Excel
  generateExcelSuccess,
  generateExcelFailure,
  importRiskAssessmentSuccess,
  importRiskAssessmentFailure,
  //import Event
  importEventSuccess,
  importEventFailure,
 









  // get user list data 
 
  editAttendanceSuccess,
  editAttendanceFailure,

  deleteNoteSuccess,
  deleteNoteFailure,
  getSubCategoriesForEventsBasedOnIdSuccess,
  getSubCategoriesForEventsBasedOnIdFailure,
  getFailureModeDataSuccess,
  getFailureModeDataFailure,
  bulkAddFailureModeDataSuccess,
  bulkAddFailureModeDataFailure,
  bulkUpdateFailureModeDataSuccess,
  bulkUpdateFailureModeDataFailure,
  deleteAttendanceSuccess,
  deleteAttendanceFailure,
  // Add event to task
  addEventToTaskSuccess,
  addEventToTaskFailure,
  // Update event for task
  updateEventForTaskSuccess,
  updateEventForTaskFailure,
  // attendance by date 
  getAttendanceByDateFailure,
  getAttendanceByDateSuccess,
  saveSessionForAttendanceSuccess,
  saveSessionForAttendanceFailure,

  //post action item
  postActionItemDataSuccess,
  postActionItemDataFailure,

  //get action item 
  getActionItemDataSuccess,
  getActionItemDataFailure,

  //update action item
  updateActionItemDataSuccess,
  updateActionItemDataFailure,

  //delete action items 
  deleteActionItemsSuccess,
  deleteActionItemsFailure,

  // get user list data
  getUserListSuccess,
  getUserListFailure,

  // Cybersecurity devices
  getDevicesSuccess,
  getDevicesFailure,
  getDeviceSuccess,
  getDeviceFailure,
  createDeviceSuccess,
  createDeviceFailure,
  saveDeviceSuccess,
  saveDeviceFailure,
  deleteDeviceSuccess,
  deleteDeviceFailure,
  getScoringReferenceSuccess,
  getScoringReferenceFailure,
} from './riskAssessmentCoreSlice';

import {limitsMock} from './mock';

// API Functions
const getRaTasksFromAPI = apiFunctions.getRiskAssessmentsTasks;
const createTaskFromAPI = apiFunctions.createTask;
const markNoEventsFromAPI = apiFunctions.markNoEvents;
const addEventSubCatFromAPI = apiFunctions.addEventSubCategory;
const deleteEventSubCatFromAPI = apiFunctions.deleteEventSubCategory;
const deleteTaskFromAPI = apiFunctions.deleteTask;
const updateTaskFromAPI = apiFunctions.updateTask;
const saveEventDetailFromAPI = apiFunctions.saveEventDetail;
const eventDetailFromAPI = apiFunctions.getEventDetail;
const updateEventDetailFromAPI = apiFunctions.updateEventDetail;
const getMachineLimitsFromAPI = apiFunctions.getMachineLimits;
const addMachineLimitsFromAPI = apiFunctions.addMachineLimits;
const uploadTaskMediaFromAPI = apiFunctions.updateTaskMedia;
const deleteTaskMediaFromAPI = apiFunctions.deleteTaskMedia
const uploadMediaFromAPI = apiFunctions.uploadMedia;
const getAssumptionFromAPI = apiFunctions.getAssumption;
const addAssumptionFromAPI = apiFunctions.addAssumption;

const getRevisionHistoryFromAPI = apiFunctions.getRevisionHistory;
const addRevisionHistoryFromAPI = apiFunctions.addRevisionHistory;

const getAttendanceFromAPI = apiFunctions.getAttendance;
const addAttendanceFromAPI = apiFunctions.addAttendance;
const getEmployeeFromAPI = apiFunctions.getEmployee;
const getSummaryFromAPI = apiFunctions.getRASummary;
const getNewAttendanceFromAPI = apiFunctions.getNewAttendanceData;

const generateExcelIdFromAPI = apiFunctions.generateExcelId;
const generateExcelFromAPI = apiFunctions.generateExcel;
const importRiskAssessmentFromAPI = apiFunctions.importRiskAssessment;
const getTaskDetailFromAPI = apiFunctions.getTaskDetail;
const importEventFromAPI = apiFunctions.importEvent;




const editAttendanceFromAPI=apiFunctions.editAttendance



const deleteNoteFromAPI = apiFunctions.deleteNote

const deleteAttendanceFromApi = apiFunctions.deleteAttendanceRecord
const attendanceByDateFromApi = apiFunctions.attendanceByDate
const saveSessionFromAPI = apiFunctions.saveAttendanceSession;

const postActionItemDataAPI =apiFunctions.actionItemData;
const getActionItemDataAPI =apiFunctions.actionItemListData;
const patchActionItemDataAPI =apiFunctions.actionItemEditData;
const deleteActionItemDataAPI =apiFunctions.actionItemDeleteData;
const getUserListDataAPI =apiFunctions.getUserListData;



const getSubCategoriesBaseddOnIdFromAPI = apiFunctions.getSubCategoriesForEventsBasedId;

const getFailureModeDataFromAPI = apiFunctions.getFailureModeData;
const bulkAddFailureModeDataFromAPI = apiFunctions.bulkAddFailureModeData;
const bulkUpdateFailureModeDataFromAPI = apiFunctions.bulkUpdateFailureModeData;
const addEventToTaskFromAPI = apiFunctions.addEventToTask;
const updateEventForTaskFromAPI = apiFunctions.updateEventForTask;

const getDevicesFromAPI = apiFunctions.getDevices;
const getDeviceFromAPI = apiFunctions.getDevice;
const createDeviceFromAPI = apiFunctions.createDevice;
const updateDeviceFromAPI = apiFunctions.updateDevice;
const deleteDeviceFromAPI = apiFunctions.deleteDevice;
const getScoringReferenceFromAPI = apiFunctions.getScoringReference;

// get risk assessments Task
async function getRaTasks(payload) {
  return await getRaTasksFromAPI(payload);
}

function* getRaTasksHandler({payload}) {
  try {
    const result = yield call(getRaTasks, payload);
    yield put(getRiskAssessmentTasksSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getRiskAssessmentTasksFailure(err));
  }
}

// create Risk Assessment task
async function createTask(payload) {
  return await createTaskFromAPI(payload);
}

function* createTaskHandler({payload}) {
  try {
    const result = yield call(createTask, payload.payload);
    payload.callback(result);
    yield put(createTaskSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(createTaskFailure(err));
  }
}

// update Risk Assessment task
async function updateTask(id, payload) {
  return await updateTaskFromAPI(id, payload);
}

function* updateTaskHandler({payload}) {
  try {
    const result = yield call(updateTask, payload.id, payload.payload);
    payload.callback(result.data);
    yield put(updateTaskSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(updateTaskFailure(err));
  }
}

//delete Notes
async function deleteNote(id) {
  return await deleteNoteFromAPI(id);
}

function* clearNotesHandler({ payload }) {
  try {
    const result = yield call(deleteNote, payload.id);
    payload.callback(result); 
    yield put(deleteNoteSuccess({ id: payload.id, message: result.message }));
  } catch (error) {
    const err = errorHandler(error);
    yield put(deleteNoteFailure(err));
  }
}


// delete Risk Assessment task
async function deleteTask(payload) {
  return await deleteTaskFromAPI(payload);
}

function* deleteTaskHandler({payload}) {
  try {
    const result = yield call(deleteTask, payload.id);
    payload.callback(result);
    yield put(deleteTaskSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(deleteTaskFailure(err));
  }
}

// update Risk Assessment task media
async function updateTaskMedia(id, payload) {
  return await uploadTaskMediaFromAPI(id, payload);
}

function* updateTaskMediaHandler({payload}) {
  try {
    const result = yield call(updateTaskMedia, payload.id, payload.payload);
    payload.callback(result.data);
    yield put(updateTaskMediaSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(updateTaskMediaFailure(err));
  }
}

//delete Task Media
async function deleteTaskMedia(id,payload) {
  return await deleteTaskMediaFromAPI(id,payload);
}

function* deleteTaskMediaHandler({ payload }) {
  try {
    const result = yield call(deleteTaskMedia, payload.id,payload.payload); 
    payload.callback(result.data); 
    yield put(deleteTaskMediaSuccess(result.data)); 
  } catch (error) {
    const err = errorHandler(error);
    yield put(deleteTaskMediaFailure(err));
  }
}


// get risk assessments Task detail
async function getTaskDetail(id) {
  return await getTaskDetailFromAPI(id);
}

function* getTaskDetailHandler({payload}) {
  try {
    const result = yield call(getTaskDetail, payload.id);
    payload.callback(result.data);
    yield put(taskDetailSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(taskDetailFailure(err));
  }
}

// get devices for a CRA
async function getDevices(craId) {
  return await getDevicesFromAPI(craId);
}

function* getDevicesHandler({payload}) {
  try {
    const result = yield call(getDevices, payload.craId);
    yield put(getDevicesSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getDevicesFailure(err));
  }
}

// get a single device
async function getDevice(id) {
  return await getDeviceFromAPI(id);
}

function* getDeviceHandler({payload}) {
  try {
    const result = yield call(getDevice, payload.id);
    payload.callback(result.data);
    yield put(getDeviceSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getDeviceFailure(err));
  }
}

// create a device
async function createDevice(payload) {
  return await createDeviceFromAPI(payload);
}

function* createDeviceHandler({payload}) {
  try {
    const result = yield call(createDevice, payload.payload);
    payload.callback(result.data);
    yield put(createDeviceSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(createDeviceFailure(err));
  }
}

// save (patch) a device
async function saveDevice(id, payload) {
  return await updateDeviceFromAPI(id, payload);
}

function* saveDeviceHandler({payload}) {
  try {
    const result = yield call(saveDevice, payload.id, payload.payload);
    payload.callback(result.data);
    yield put(saveDeviceSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(saveDeviceFailure(err));
  }
}

// delete a device
async function deleteDevice(id) {
  return await deleteDeviceFromAPI(id);
}

function* deleteDeviceHandler({payload}) {
  try {
    const result = yield call(deleteDevice, payload.id);
    payload.callback(result.data);
    yield put(deleteDeviceSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(deleteDeviceFailure(err));
  }
}

// get the scoring reference
async function getScoringReference() {
  return await getScoringReferenceFromAPI();
}

function* getScoringReferenceHandler({payload}) {
  try {
    const result = yield call(getScoringReference);
    if (typeof payload?.callback === 'function') {
      payload.callback(result.data);
    }
    yield put(getScoringReferenceSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getScoringReferenceFailure(err));
  }
}

export function* riskAssessmentTasksWatcher() {
  yield takeLatest(
    'riskAssessmentCore/getRiskAssessmentTasks',
    getRaTasksHandler,
  );
  yield takeLatest('riskAssessmentCore/createTask', createTaskHandler);
  yield takeLatest('riskAssessmentCore/deleteTask', deleteTaskHandler);
  yield takeLatest('riskAssessmentCore/updateTask', updateTaskHandler);
  yield takeLatest(
    'riskAssessmentCore/updateTaskMedia',
    updateTaskMediaHandler,
  );
  yield takeLatest('riskAssessmentCore/getTaskDetail', getTaskDetailHandler);
  yield takeLatest('riskAssessmentCore/deleteTaskMedia',deleteTaskMediaHandler)
  yield takeLatest('riskAssessmentCore/getDevices', getDevicesHandler);
  yield takeLatest('riskAssessmentCore/getDevice', getDeviceHandler);
  yield takeLatest('riskAssessmentCore/createDevice', createDeviceHandler);
  yield takeLatest('riskAssessmentCore/saveDevice', saveDeviceHandler);
  yield takeLatest('riskAssessmentCore/deleteDevice', deleteDeviceHandler);
  yield takeLatest(
    'riskAssessmentCore/getScoringReference',
    getScoringReferenceHandler,
  );
}

// Mark 'No' Exposure to unwanted Events
async function markNoEvents(id, payload) {
  return await markNoEventsFromAPI(id, payload);
}

function* noExpHandler({payload}) {
  try {
    const result = yield call(markNoEvents, payload.id, payload.payload);
    payload.callback(result);
    yield put(markNoExpToUnWantedEventsSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(markNoExpToUnWantedEventsFailure(err));
  }
}

// Add event to task
async function addEventToTask(taskId, payload) {
  return await addEventToTaskFromAPI(taskId, payload);
}

function* addEventToTaskHandler({payload}) {
  try {
    const result = yield call(addEventToTask, payload.taskId, payload.payload);
    yield put(addEventToTaskSuccess(result.data));
    
    // Refetch task detail to update event task mapping
    if (payload.taskId) {
      yield put({
        type: 'riskAssessmentCore/getTaskDetail',
        payload: {
          id: payload.taskId,
          callback: payload.callback || (() => {}),
        },
      });
    }
  } catch (error) {
    const err = errorHandler(error);
    yield put(addEventToTaskFailure(err));
  }
}

// Update event for task
async function updateEventForTask(taskId, eventId, payload) {
  return await updateEventForTaskFromAPI(taskId, eventId, payload);
}

function* updateEventForTaskHandler({payload}) {
  try {
    const result = yield call(
      updateEventForTask,
      payload.taskId,
      payload.eventId,
      payload.payload,
    );
    yield put(updateEventForTaskSuccess(result.data));
    
    // Refetch task detail to update event task mapping
    if (payload.taskId) {
      yield put({
        type: 'riskAssessmentCore/getTaskDetail',
        payload: {
          id: payload.taskId,
          callback: payload.callback || (() => {}),
        },
      });
    }
  } catch (error) {
    const err = errorHandler(error);
    yield put(updateEventForTaskFailure(err));
  }
}

// Add Event Subcategory
async function addEventSubCat(payload) {
  return await addEventSubCatFromAPI(payload);
}

function* addEventSubCategory({payload}) {
  try {
    const result = yield call(addEventSubCat, payload.payload);
    payload.callback(result);
    yield put(addSubCategoryEventsSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(addSubCategoryEventsFailure(err));
  }
}

// Delete an Event from Subcategory
async function deleteEventSubCat(id, payload) {
  return await deleteEventSubCatFromAPI(id, payload);
}

function* deleteEventSubCategory({payload}) {
  try {
    const result = yield call(deleteEventSubCat, payload.id, payload.payload);
    payload.callback(result);
    yield put(deleteSubCategoryEventsSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(deleteSubCategoryEventsFailure(err));
  }
}

// get sub categories based on event
async function getSubCategoriesForEventsBasedOnId(id) {
  return await getSubCategoriesBaseddOnIdFromAPI(id);
}

function* getSubCategoriesForEventsBasedOnIdHandler({payload}) {
  try {
    const result = yield call(getSubCategoriesForEventsBasedOnId, payload);
    yield put(getSubCategoriesForEventsBasedOnIdSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getSubCategoriesForEventsBasedOnIdFailure(err));
  }
}


// get sub categories based on event


async function getFailureModeData(params) {
  return await getFailureModeDataFromAPI(params);
}

async function bulkAddFailureModeData(payload) {
  return await bulkAddFailureModeDataFromAPI(payload);
}

async function bulkUpdateFailureModeData(payload) {
  return await bulkUpdateFailureModeDataFromAPI(payload);
}

function* getFailureModeDataHandler({payload}) {
  try {
    const result = yield call(getFailureModeData, payload);
    yield put(getFailureModeDataSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getFailureModeDataFailure(err));
  }
}

function* bulkAddFailureModeDataHandler({payload}) {
  try {
    const result = yield call(bulkAddFailureModeData, payload.payload);
    payload.callback(result);
    yield put(bulkAddFailureModeDataSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(bulkAddFailureModeDataFailure(err));
  }
}

function* bulkUpdateFailureModeDataHandler({payload}) {
  try {
    const result = yield call(bulkUpdateFailureModeData, payload.payload);
    payload.callback(result);
    yield put(bulkUpdateFailureModeDataSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(bulkUpdateFailureModeDataFailure(err));
  }
}




async function saveEventDetail(payload) {
  return await saveEventDetailFromAPI(payload);
}

function* saveEventDetailHandler({payload}) {
  try {
    const result = yield call(saveEventDetail, payload.payload);
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(saveEventDetailSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    if (payload.callback) {
      payload.callback({status: error.response?.status});
    }
    yield put(saveEventDetailFailure(err));
  }
}

async function eventDetail(payload) {
  return await eventDetailFromAPI(payload);
}

function* eventDetailHandler({payload}) {
  try {
    const result = yield call(eventDetail, payload.payload);
    payload.callback(result.data);
    yield put(eventDetailSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(eventDetailFailure(err));
  }
}

async function updateEventDetail(id, payload) {
  return await updateEventDetailFromAPI(id, payload);
}

function* updateEventDetailHandler({payload}) {
  try {
    const result = yield call(updateEventDetail, payload.id, payload.payload);
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(updateEventDetailSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    if (payload.callback) {
      payload.callback({status: error.response?.status});
    }
    yield put(updateEventDetailFailure(err));
  }
}

// update Risk Assessment task media
async function uploadMedia(payload) {
  return await uploadMediaFromAPI(payload);
}

function* uploadMediaHandler({payload}) {
  try {
    const result = yield call(uploadMedia, payload.payload);
    payload.callback(result.data);
    yield put(uploadMediaSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(uploadMediaFailure(err));
  }
}

async function generateExcelId(payload) {
  return await generateExcelIdFromAPI(payload);
}

function* generateExcelIdHandler({payload}) {
  try {
    const result = yield call(generateExcelId, payload.payload);
    payload.callback(result.data);
    yield put(generateExcelIdSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(generateExcelIdFailure(err));
  }
}

async function generateExcel(id) {
  return await generateExcelFromAPI(id);
}

function* generateExcelHandler({payload}) {
  try {
    const result = yield call(generateExcel, payload.payload.id);
    payload.callback(result.data);
    yield put(generateExcelSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(generateExcelFailure(err));
  }
}

async function importEvent(payload) {
  return await importEventFromAPI(payload);
}

async function importRiskAssessmentHandlerAPI(file, productId, machineId) {
  return await importRiskAssessmentFromAPI(file, productId, machineId);
}

function* importRiskAssessmentHandler({payload}) {
  try {
    const result = yield call(
      importRiskAssessmentHandlerAPI,
      payload.file,
      payload.productId,
      payload.machineId
    );
    payload.callback && payload.callback(result.data);
    yield put(importRiskAssessmentSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    // Call callback with error response so component can reset loading state
    payload.callback && payload.callback({success: false, error: err.error || err.message || 'Import failed'});
    yield put(importRiskAssessmentFailure(err));
  }
}

function* importEventHandler({payload}) {
  try {
    const result = yield call(importEvent, payload.payload);
    payload.callback(result.data);
    yield put(importEventSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(importEventFailure(err));
  }
}

export function* EventsWatcher() {
  yield takeLatest(
    'riskAssessmentCore/markNoExpToUnWantedEvents',
    noExpHandler,
  );
  yield takeLatest(
    'riskAssessmentCore/addSubCategoryEvents',
    addEventSubCategory,
  );
  yield takeLatest(
    'riskAssessmentCore/deleteSubCategoryEvents',
    deleteEventSubCategory,
  );
  yield takeLatest(
    'riskAssessmentCore/saveEventDetail',
    saveEventDetailHandler,
  );
  yield takeLatest('riskAssessmentCore/getEventDetail', eventDetailHandler);
  yield takeLatest(
    'riskAssessmentCore/updateEventDetail',
    updateEventDetailHandler,
  );
  yield takeLatest(
    'riskAssessmentCore/addEventToTask',
    addEventToTaskHandler,
  );
  yield takeLatest(
    'riskAssessmentCore/updateEventForTask',
    updateEventForTaskHandler,
  );
  yield takeLatest('riskAssessmentCore/uploadMedia', uploadMediaHandler);
  yield takeLatest(
    'riskAssessmentCore/generateExcelId',
    generateExcelIdHandler,
  );
  yield takeLatest('riskAssessmentCore/generateExcel', generateExcelHandler);
  yield takeLatest('riskAssessmentCore/importRiskAssessment', importRiskAssessmentHandler);
  yield takeLatest('riskAssessmentCore/importEvent', importEventHandler);
  yield takeLatest(
    'riskAssessmentCore/deleteNotes',
    clearNotesHandler,
  );
  yield takeLatest(
    'riskAssessmentCore/subCategoriesBasedOnId',
    getSubCategoriesForEventsBasedOnIdHandler
  );

  yield takeLatest(
    'riskAssessmentCore/subCategoriesBasedOnId',
    getSubCategoriesForEventsBasedOnIdHandler
  );
  yield takeLatest(
    'riskAssessmentCore/getFailureModeData',
    getFailureModeDataHandler
  );
  yield takeLatest(
    'riskAssessmentCore/bulkAddFailureModeData',
    bulkAddFailureModeDataHandler
  );
  yield takeLatest(
    'riskAssessmentCore/bulkUpdateFailureModeData',
    bulkUpdateFailureModeDataHandler
  );
}

// ----------------------------- Nested data Risk Assessment -----------------------------------
// get Machine limits
async function getMachineLimits(id) {
  // return limitsMock
  return await getMachineLimitsFromAPI(id);
}

function* machineLimitsHandler({payload}) {
  try {
    const result = yield call(getMachineLimits, payload);
    // payload.callback(result)
    yield put(getMachineLimitsSuccess({raId: payload, data: result.data}));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getMachineLimitsFailure(err));
  }
}
// add Machine limits
async function addMachineLimits(id, payload) {
  return await addMachineLimitsFromAPI(id, payload);
}

function* addMachineLimitsHandler({payload}) {
  try {
    const result = yield call(addMachineLimits, payload.id, payload.payload);
    payload.callback(result);
    yield put(addMachineLimitsSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(addMachineLimitsFailure(err));
  }
}

// add Assumption
async function addAssumptions(id, payload) {
  return await addAssumptionFromAPI(id, payload);
}

function* addAssumptionsHandler({payload}) {
  try {
    const result = yield call(addAssumptions, payload.id, payload.payload);
    payload.callback(result);
    yield put(addAssumptionSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(addAssumptionFailure(err));
  }
}

// get Assumption
async function getAssumption(id) {
  return await getAssumptionFromAPI(id);
}

function* getAssumptionsHandler({payload}) {
  try {
    const result = yield call(getAssumption, payload);
    yield put(getAssumptionSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getAssumptionFailure(err));
  }
}

// add RevisionHistory
async function addRevisionHistory(id, payload) {
  return await addRevisionHistoryFromAPI(id, payload);
}

function* adRevisionHistoryHandler({payload}) {
  try {
    const result = yield call(addRevisionHistory, payload.id, payload.payload);
    payload.callback(result);
    yield put(addRevisionHistorySuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(addRevisionHistoryFailure(err));
  }
}

// get revision history
async function getRevisionHistory(id) {
  return await getRevisionHistoryFromAPI(id);
}

function* getRevisionHistoryHandler({payload}) {
  try {
    const result = yield call(getRevisionHistory, payload);
    yield put(getRevisionHistorySuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getRevisionHistoryFailure(err));
  }
}

// add attendance
async function addAttendance(payload) {
  return await addAttendanceFromAPI(payload);
}

function* addAttendanceHandler({payload}) {
  try {
    const result = yield call(addAttendance, payload.payload);
    payload.callback(result);
    yield put(addAttendanceSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(addAttendanceFailure(err));
  }
}

// get attendance
async function getAttendance(id) {
  return await getAttendanceFromAPI(id);
}

function* getAttendanceHandler({payload}) {
  try {
    const result = yield call(getAttendance, payload);
    yield put(getAttendanceSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getAttendanceFailure(err));
  }
}

//get new attendance api
async function getNewAttendanceData(riskAssessmentId) {
  return await getNewAttendanceFromAPI(riskAssessmentId);
}

function* getNewAttendanceHandler({ payload }) {
  try {
    const result = yield call(getNewAttendanceData,payload.riskAssessmentId);
    yield put(getAttendanceSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getAttendanceFailure(err));
  }
}


// get Employee
async function getEmployee() {
  return await getEmployeeFromAPI();
}

function* getEmployeeHandler() {
  try {
    const result = yield call(getEmployee);
    yield put(getEmployeeSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getEmployeeFailure(err));
  }
}

// get Summary
async function getSummary(payload) {
  return await getSummaryFromAPI(payload);
}

function* getSummaryHandler({payload}) {
  try {
    const result = yield call(getSummary, payload);
    yield put(getSummarySuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getSummaryFailure(err));
  }
}

// API call function for deleting attendance
async function deleteAttendance(data) {
  return await deleteAttendanceFromApi(data);
}

function* deleteAttendanceHandler({ payload }) {
  try {
    const result = yield call(deleteAttendance, payload);
    if (payload.callback) {
      payload.callback(result);
    }

    yield put(deleteAttendanceSuccess({ date: payload?.id, message: result.message }));
  } catch (error) {
    const err = errorHandler(error);
    yield put(deleteAttendanceFailure(err));
  }
}

//API call function for Attendance By Date
async function attendanceByDate(date) {
  return await attendanceByDateFromApi(date);
}

function* attendanceByDateHandler({ payload }) {
  try {
    const result = yield call(attendanceByDate, payload);
    yield put(getAttendanceByDateSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getAttendanceByDateFailure(err));
  }
}

//save session for attendance
async function saveSessionForAttendance(payload) {
  return await saveSessionFromAPI(payload);
}

function* saveSessionForAttendanceeHandler({payload}) {
  try {
    const result = yield call(saveSessionForAttendance, payload.payload);
    payload.callback(result);
    yield put(saveSessionForAttendanceSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(saveSessionForAttendanceFailure(err));
  }
}

//post action list
async function postActionItemData(id,payload) { 
  return await postActionItemDataAPI(id,payload);
}

function* ActionItemDataHandler({payload}) {
  try {
    const result = yield call(postActionItemData,payload.id, payload.payload);
    payload.callback(result); 
    yield put(postActionItemDataSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(postActionItemDataFailure(err));
  }
}

// action item get
async function getActionItemData(payload) {
  // console.log('payloadss',payload);
  
  return await getActionItemDataAPI(payload);
}

function* GetActionItemDataHandler(payload) {
  // console.log('payload',payload);
  
  try {
    const result = yield call(getActionItemData, payload.payload);
    // console.log('result',result);
    
    yield put(getActionItemDataSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getActionItemDataFailure(err));
  }
}

///update action items

async function updateActionItemData(id, payload) {
  return await patchActionItemDataAPI(id, payload);
}

function* PatchActionItemDataHandler({payload}) {
  try {
    const result = yield call(updateActionItemData, payload.id, payload.payload);
    payload.callback(result.data);
    yield put(updateActionItemDataSuccess(result.data));
  } catch (error) {
    const err = errorHandler(error);
    yield put(updateActionItemDataFailure(err));
  }
}

// delete action items 
async function deleteActionItems(id) {
  return await deleteActionItemDataAPI(id);
}

function* DeleteActionItemHandler({ payload }) {
  try {
    const result = yield call(deleteActionItems, payload.id);
    payload.callback(result); 
    yield put(deleteActionItemsSuccess({ id: payload.id, message: result.message }));
  } catch (error) {
    const err = errorHandler(error);
    yield put(deleteActionItemsFailure(err));
  }
}


// get user list data
async function getUserList() {
  return await getUserListDataAPI();
}

function* getUserListHandler() {
  try {
    const result = yield call(getUserList);
    yield put(getUserListSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(getUserListFailure(err));
  }
} 



async function editAttendance( payload) {
  return await editAttendanceFromAPI( payload);
}

function* editAttendanceHandler({ payload }) {
  try {
    const result = yield call(editAttendance, payload.data);
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(editAttendanceSuccess(result));
  } catch (error) {
    const err = errorHandler(error);
    yield put(editAttendanceFailure(err));
  }
}

export function* riskAssessmentNestedDataWatcher() {
  yield takeLatest('riskAssessmentCore/getMachineLimits', machineLimitsHandler);
  yield takeLatest(
    'riskAssessmentCore/addMachineLimits',
    addMachineLimitsHandler,
  );
  yield takeLatest('riskAssessmentCore/addAssumption', addAssumptionsHandler);
  yield takeLatest('riskAssessmentCore/getAssumptions', getAssumptionsHandler);

  yield takeLatest(
    'riskAssessmentCore/addRevisionHistory',
    adRevisionHistoryHandler,
  );
  yield takeLatest(
    'riskAssessmentCore/getRevisionHistory',
    getRevisionHistoryHandler,
  );
  yield takeLatest('riskAssessmentCore/addAttendance', addAttendanceHandler);
  yield takeLatest('riskAssessmentCore/getAttendance', getAttendanceHandler);
  yield takeLatest('riskAssessmentCore/getEmployee', getEmployeeHandler);
  yield takeLatest('riskAssessmentCore/getSummary', getSummaryHandler);
  yield takeLatest('riskAssessmentCore/getNewAttendance',getNewAttendanceHandler);
  yield takeLatest('riskAssessmentCore/deleteAttendance',deleteAttendanceHandler)
  yield takeLatest('riskAssessmentCore/attendanceByDate',attendanceByDateHandler)
  yield takeLatest('riskAssessmentCore/saveSessionForAttendance',saveSessionForAttendanceeHandler)
  yield takeLatest('riskAssessmentCore/postActionItemData',ActionItemDataHandler)
  yield takeLatest('riskAssessmentCore/getActionItemData',GetActionItemDataHandler)
  yield takeLatest('riskAssessmentCore/updateActionItemData',PatchActionItemDataHandler)
  yield takeLatest('riskAssessmentCore/deleteActionItems',DeleteActionItemHandler)
  yield takeLatest('riskAssessmentCore/getUserList',getUserListHandler)


  yield takeLatest('riskAssessmentCore/editAttendance',editAttendanceHandler)

}
